import React from "react";

const WhyIcmFirst = () => (
    <svg width="34" height="36" viewBox="0 0 34 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0433 35.7866C16.5972 36.0724 17.2924 36.0705 17.8463 35.7847C32.9411 27.95 34.0131 12.6429 33.9999 8.29048C33.9984 7.94066 33.8915 7.59885 33.692 7.30689C33.4926 7.01493 33.2094 6.78551 32.877 6.64672L17.7107 0.15542C17.4693 0.0526255 17.2084 -0.000312086 16.9446 1.38405e-06C16.6809 0.000314854 16.4201 0.0538723 16.179 0.157241L1.11815 6.64854C0.790704 6.78741 0.511474 7.01429 0.313729 7.30218C0.115984 7.59006 0.00806029 7.9268 0.002815 8.27227C-0.0612415 12.6028 0.841202 27.9428 16.0433 35.7866ZM10.7417 14.9238L15.0618 19.0978L23.1498 11.2831L25.8138 13.857L15.0618 24.2457L8.07771 17.4977L10.7417 14.9238Z" fill="#283A97" />
    </svg>

)

export default WhyIcmFirst;